module.exports = __webpack_public_path__ + "media/images/icons/bar-564c95213ba8c30238d62d7baf8bf472.png";